<template lang="html">
    <div ref="movableContainer" class="column-chooser-popup" @click.stop="" >
        <div class="column-chooser-popup-content">
            <div class="column-chooser-popup-header" ref="moveButton" :draggable="draggable" @mousedown="dragStart" @mouseup="dragEnd">
                <p>Column Chooser</p>
                <i class="close fas fa-times" @click="onCloseClicked()"></i>
            </div>
            <div class="column-chooser-body">
                <div class="column-chooser-option" v-for="option in inspectionPropertiesWithCheck" :key="option.name">
                    <input type="checkbox" v-model="option.isChecked" :name="option.name" :id="`chooser-option-${option.name}`">
                    <label :for="`chooser-option-${option.name}`">{{option.name}}</label>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ColumnChooserPopup',
    components: {
    },
    props: {
        draggable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            isMoving: false,
            initialX: 0,
            initialY: 0,
            xOffset: 0,
            yOffset: 0,
        };
    },
    computed: {
        isAMIS(){
            return !!this.$store.state.forgeSettings?.isAMIS;
        },
        inspectionPropertiesWithCheck: {
            get() {
                let result = this.$store.getters.GET_INSPECTION_PROPERTIES_WITH_CHECK

                if (!this.isAMIS)  {
                    const amisAdditionalColumns = ['A-MIS Link', 'Base specification Url', 'Thickness history Url']
                    result = result.filter((option) => !amisAdditionalColumns.includes(option.name))
                }

                return result;
            },
            set(value) {
                this.$store.commit('SET_INSPECTION_PROPERTIES_WITH_CHECK', value);
            }
        },
        selectedInspectionProperties: {
            get() {
                return this.inspectionPropertiesWithCheck.filter((option) => option.isChecked).map((option) => option.name);
            },
        },
    },
    methods: {
        dragStart(e) {
            if (!this.draggable) return;
            this.initialX = e.clientX - this.xOffset;
            this.initialY = e.clientY - this.yOffset;
            if (e.target === this.$refs.moveButton) {
                this.isMoving = true;
                this.$refs.movableContainer.style.transition = "none";
            }
        },
        dragEnd() {
            if (!this.draggable) return;
            this.isMoving = false;
            this.$refs.movableContainer.style.transition = "all 0.3s ease";
        },
        mouseMove(e) {
            if (!this.draggable) return;
            if (this.isMoving) {
                e.preventDefault();
                let currentX = e.clientX - this.initialX;
                let currentY = e.clientY - this.initialY;
                this.xOffset = currentX;
                this.yOffset = currentY;
                this.setTranslate(currentX, currentY, this.$refs.movableContainer);
            }
        },
        setTranslate(xPos, yPos, el) {
            el.style.transform = `translate3d(${xPos}px, ${yPos}px, 0)`;
        },
        onCloseClicked() {
            this.$store.commit('SET_SHOW_COLUMN_CHOOSER_POPUP', false);
        }
    },
    mounted() {
        document.addEventListener("mousemove", this.mouseMove);
    },
    destroyed() {
        document.removeEventListener("mousemove", this.mouseMove);
    },
    watch: {
        selectedInspectionProperties: {
            handler() {
                let encodedKey = btoa('inspectionPropertiesWithCheck');
                localStorage.setItem(encodedKey, JSON.stringify(this.inspectionPropertiesWithCheck));
            }
        }
    },
}
</script>
<style lang="css">
.column-chooser-popup {
    width: 300px;
    height: 450px;
    position: absolute;
    top: 50px;
    right: 50px;
    background-color: white;
    box-shadow: 1px 3px 10px 0 rgb(0 0 0 / 50%);
    border-radius: 5px;
    display: block;
    z-index: 9;
}

.dark-theme .column-chooser-popup {
    background-color: #22272B;
}

.dark-theme .column-chooser-option {
    border-bottom: 1px solid #3a3a3a;
    color: white;
}

.dark-theme .column-chooser-option label {
    color: white;
}

.column-chooser-popup-content {
    display: flex;
    flex-direction: column;
    height: -webkit-fill-available;
}

.column-chooser-popup .column-chooser-popup-header {
    background: var(--primary-color);
    border-radius: 5px 5px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 10px;
}

.column-chooser-popup .column-chooser-popup-header p {
    font-weight: bold;
    font-size: 14px;
    margin: 5px;
    color: #f2f2f2;
    user-select: none;
}

.column-chooser-popup .column-chooser-popup-header .fas.fa-times {
    font-size: 16px;
    color: var(--light-primary-color);
    padding: 0px;
}

.column-chooser-popup .column-chooser-popup-header .fas.fa-times:hover {
    color: white;
}

.column-chooser-body {
    display: flex;
    flex-direction: column;
    max-height: 100%;
    overflow-y: auto;
}

.column-chooser-option {
    display: flex;
    align-items: center;
    padding: 5px 5px;
    border-bottom: 1px solid #e2e2e2;
    cursor: pointer;
}

.column-chooser-option label {
    font-size: 14px;
    width: 100%;
    font-weight: 400;
    color: #333;
    user-select: none;
}

.column-chooser-option label:hover {
    cursor: pointer;
}

.column-chooser-option input[type="checkbox"] {
    width: 15px;
    height: 15px;
    margin-right: 10px;
}

.column-chooser-option input[type="checkbox"]:hover {
    cursor: pointer;
}
</style>